import * as Schema from "effect/Schema";
import { TrimmedString } from "./baseSchemas.js";
export const MAX_KEYBINDING_VALUE_LENGTH = 64;
export const MAX_KEYBINDING_WHEN_LENGTH = 256;
export const MAX_WHEN_EXPRESSION_DEPTH = 64;
export const MAX_KEYBINDINGS_COUNT = 256;
export const THREAD_JUMP_KEYBINDING_COMMANDS = [
    "thread.jump.1",
    "thread.jump.2",
    "thread.jump.3",
    "thread.jump.4",
    "thread.jump.5",
    "thread.jump.6",
    "thread.jump.7",
    "thread.jump.8",
    "thread.jump.9",
];
export const THREAD_KEYBINDING_COMMANDS = [
    "thread.previous",
    "thread.next",
    ...THREAD_JUMP_KEYBINDING_COMMANDS,
];
const STATIC_KEYBINDING_COMMANDS = [
    "commandPalette.toggle",
    "chat.new",
    "chat.newLocal",
    ...THREAD_KEYBINDING_COMMANDS,
];
export const KeybindingCommand = Schema.Literals(STATIC_KEYBINDING_COMMANDS);
export const KeybindingValue = TrimmedString.check(Schema.isMinLength(1), Schema.isMaxLength(MAX_KEYBINDING_VALUE_LENGTH));
export const KeybindingWhen = TrimmedString.check(Schema.isMinLength(1), Schema.isMaxLength(MAX_KEYBINDING_WHEN_LENGTH));
export const KeybindingRule = Schema.Struct({
    key: KeybindingValue,
    command: KeybindingCommand,
    when: Schema.optional(KeybindingWhen),
});
export const KeybindingsConfig = Schema.Array(KeybindingRule).check(Schema.isMaxLength(MAX_KEYBINDINGS_COUNT));
export const KeybindingShortcut = Schema.Struct({
    key: KeybindingValue,
    metaKey: Schema.Boolean,
    ctrlKey: Schema.Boolean,
    shiftKey: Schema.Boolean,
    altKey: Schema.Boolean,
    modKey: Schema.Boolean,
});
const KeybindingWhenNodeRef = Schema.suspend(() => KeybindingWhenNode);
export const KeybindingWhenNode = Schema.Union([
    Schema.Struct({
        type: Schema.Literal("identifier"),
        name: Schema.NonEmptyString,
    }),
    Schema.Struct({
        type: Schema.Literal("not"),
        node: KeybindingWhenNodeRef,
    }),
    Schema.Struct({
        type: Schema.Literal("and"),
        left: KeybindingWhenNodeRef,
        right: KeybindingWhenNodeRef,
    }),
    Schema.Struct({
        type: Schema.Literal("or"),
        left: KeybindingWhenNodeRef,
        right: KeybindingWhenNodeRef,
    }),
]);
export const ResolvedKeybindingRule = Schema.Struct({
    command: KeybindingCommand,
    shortcut: KeybindingShortcut,
    whenAst: Schema.optional(KeybindingWhenNode),
}).annotate({ parseOptions: { onExcessProperty: "ignore" } });
export const ResolvedKeybindingsConfig = Schema.Array(ResolvedKeybindingRule).check(Schema.isMaxLength(MAX_KEYBINDINGS_COUNT));
export class KeybindingsConfigError extends Schema.TaggedError()("KeybindingsConfigParseError", {
    configPath: Schema.String,
    detail: Schema.String,
    cause: Schema.optional(Schema.Defect()),
}) {
    get message() {
        return `Unable to parse keybindings config at ${this.configPath}: ${this.detail}`;
    }
}
